// Fulfillment → Forms mode — Turbo Sign monitor stub (TS-5 pilot entry point).
// Paste a contract instance UUID from instance-send to monitor status, resend, and void.

import { useState } from "react";
import { SignInstancePanel } from "@/components/sign/SignInstancePanel";
import { useAnchorEntitlements } from "@/contexts/AnchorEntitlementsContext";
import { turboSignEntitlementEnabled } from "@/lib/sign/turboSignEntitlement";

const STORAGE_KEY = "turbo_sign_demo_instance_id";

export function FulfillmentSignMonitorSection() {
  const { anchors } = useAnchorEntitlements();
  const turboSignEnabled = turboSignEntitlementEnabled(anchors);
  const [inputId, setInputId] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) ?? "";
    } catch {
      return "";
    }
  });
  const [activeId, setActiveId] = useState(inputId);

  function handleLoad() {
    const trimmed = inputId.trim();
    setActiveId(trimmed);
    try {
      if (trimmed) localStorage.setItem(STORAGE_KEY, trimmed);
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore storage errors
    }
  }

  return (
    <section className="space-y-3 rounded-xl border border-dashed border-indigo-200 bg-indigo-50/30 p-4 dark:border-indigo-900 dark:bg-indigo-950/20">
      <header className="space-y-1">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-zinc-100">Turbo Sign monitor (pilot)</h3>
        <p className="text-xs text-gray-600 dark:text-zinc-400">
          Track envelope status, resend reminders, or void (managers). Use the instance id returned from send.
        </p>
      </header>
      {!turboSignEnabled ? (
        <p className="text-xs text-amber-800 dark:text-amber-200">
          Turbo Sign is not enabled for this organization.
        </p>
      ) : (
        <>
      <div className="flex flex-wrap items-end gap-2">
        <label className="min-w-[16rem] flex-1 text-xs">
          <span className="text-gray-500">Contract instance id</span>
          <input
            type="text"
            value={inputId}
            onChange={(e) => setInputId(e.target.value)}
            placeholder="22222222-2222-4222-9222-222222222222"
            className="mt-1 w-full rounded-lg border border-gray-200 px-2 py-1.5 font-mono text-sm dark:border-zinc-700 dark:bg-zinc-800"
          />
        </label>
        <button
          type="button"
          onClick={handleLoad}
          disabled={!inputId.trim()}
          className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
        >
          Load
        </button>
      </div>
      {activeId.trim() ? <SignInstancePanel instanceId={activeId.trim()} /> : null}
        </>
      )}
    </section>
  );
}
